import { useRef, useState } from "react";
import { Paperclip, X, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { uploadFile, errMsg, openFile } from "@/lib/api";

export function FileUpload({ value = [], onChange, testId = "file-upload", stage }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const uploaded = [];
      for (const f of files) {
        const r = await uploadFile(f);
        uploaded.push({ file_id: r.id, name: r.original_filename, size: r.size, content_type: r.content_type, stage });
      }
      onChange([...(value || []), ...uploaded]);
      toast.success(`${uploaded.length} file terunggah`);
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="space-y-2">
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testId}-btn`}
        className="flex w-full items-center justify-center gap-2 rounded-md border border-dashed p-3 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-foreground">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paperclip className="h-4 w-4" />} {busy ? "Mengunggah..." : "Pilih file (foto/PDF, maks 15MB)"}
      </button>
      <input ref={ref} type="file" multiple className="hidden" onChange={pick} data-testid={`${testId}-input`} />
      {value?.length > 0 && (
        <ul className="space-y-1">
          {value.map((a, i) => (
            <li key={a.file_id || i} className="flex items-center gap-2 rounded-md bg-muted px-2 py-1 text-xs">
              <Paperclip className="h-3 w-3" /><span className="truncate flex-1">{a.name}</span>
              <button type="button" onClick={() => openFile(a.file_id)} className="text-muted-foreground hover:text-foreground"><ExternalLink className="h-3 w-3" /></button>
              <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-muted-foreground hover:text-destructive" data-testid={`${testId}-remove-${i}`}><X className="h-3 w-3" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function AttachmentList({ items = [] }) {
  if (!items.length) return <p className="text-xs text-muted-foreground">Tidak ada lampiran</p>;
  return (
    <ul className="space-y-1">
      {items.map((a, i) => (
        <li key={a.file_id || `${a.name}-${i}`}>
          <button type="button" onClick={() => openFile(a.file_id)} className="flex w-full items-center gap-2 rounded-md bg-muted px-2 py-1.5 text-xs hover:bg-accent" data-testid={`attachment-${i}`}>
            <Paperclip className="h-3 w-3" /><span className="truncate flex-1 text-left">{a.name}</span>
            {a.stage && <span className="font-mono text-[10px] uppercase text-muted-foreground">{a.stage}</span>}
          </button>
        </li>
      ))}
    </ul>
  );
}
